// Function loadDownloadBriefBlock loads the DownloadBriefBlock class by dynamically importing the js on demand if needed

export function loadDownloadBriefBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-download-brief-block-chunk" */ '../widgets/downloadBriefBlock').then(wg => {

		const { DownloadBriefBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="DownloadBriefBlock"]');

		if(!$wg) {
			// console.info('DownloadBriefBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="DownloadBriefBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new DownloadBriefBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new DownloadBriefBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the DownloadBriefBlock widget');

}
